export const ENERGY_EFFICIENCY = {
  logicMap: [
    {
      unique_names_combination: 'double no_gas',
      image: {
        url: 'assets/icons/energy-efficiency/default.svg',
      },
      uvalue: 'U-value = ~.48',
    },
    {
      unique_names_combination: 'double argon',
      image: {
        url: 'assets/icons/energy-efficiency/two_gas.svg',
      },
      uvalue: 'U-value = ~.26',
    },
    {
      unique_names_combination: 'triple no_gas',
      image: {
        url: 'assets/icons/energy-efficiency/three_nogas.svg',
      },
      uvalue: 'U-value = ~.31',
    },
    {
      unique_names_combination: 'triple argon',
      image: {
        url: 'assets/icons/energy-efficiency/three_gas.svg',
      },
      uvalue: 'U-value = ~.18',
    },
  ],
  glassOptions: {
    title: 'Glass options',
    glassOptionsList: [
      {
        unique_name: 'double',
        name: 'Double pane $$',
        selected: true,
      },
      {
        unique_name: 'triple',
        name: 'Triple pane $$$',
        selected: false,
      },
    ],
  },
  gasOptions: {
    title: 'Gas',
    gasOptionsList: [
      {
        unique_name: 'no_gas',
        name: 'None',
        selected: true,
      },
      {
        unique_name: 'argon',
        name: 'Argon $$',
        selected: false,
      },
    ],
  }
};
